<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import overtime from "@/utils/overtime";
import { MessageBox } from "element-ui";

export default {
  name: "App",
  computed: {
    ...mapGetters("user", ["username"]),
    // 根据当前路由的指定布局设置组件名称
    layout() {
      return "layout-" + (this.$route?.meta.layout || "blank").toLowerCase();
    },
  },
  watch: {
    /**
     * 根据用户信息开启监听空闲时间
     */
    username() {
      overtime(this.handleOvertime);
    },
  },
  methods: {
    handleOvertime() {
      this.$store.dispatch("user/logout");
      MessageBox.alert("检测到您长时间没有操作，请重新登录。", "安全提示", {
        type: "warning",
        confirmButtonText: "知道了",
      });
    },
  },
  created() {
    // 获取平台信息
    this.$store.dispatch("app/getPlatformInfo");
  },
};
</script>

<style>
@font-face {
  font-family: "jiangxizhuokai";
  src: url("./assets/fonts/jiangxizhuokai.ttf");
}
</style>
